import { render } from "./VouchersForConvert.vue?vue&type=template&id=233bb019"
import script from "./VouchersForConvert.vue?vue&type=script&lang=js"
export * from "./VouchersForConvert.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__